/**
 * Utility functions for filter validation logic
 */

export interface ValidationErrors {
  state: string;
  insurance: string;
}

/**
 * Determines if an error should be displayed for a specific field
 * @param showValidationMessage - Whether validation messages should be shown
 * @param errors - The errors object
 * @param field - The field to check (state or insurance)
 * @returns The error message if it should be displayed, undefined otherwise
 */
export const getFieldError = (
  showValidationMessage: boolean,
  errors: ValidationErrors | undefined,
  field: keyof ValidationErrors
): string | undefined => {
  return showValidationMessage && errors?.[field] ? errors[field] : undefined;
};

/**
 * Creates error objects for state and insurance fields
 * @param showValidationMessage - Whether validation messages should be shown
 * @param errors - The errors object
 * @returns Object with stateError and insuranceError properties
 */
export const getValidationErrors = (
  showValidationMessage: boolean,
  errors: ValidationErrors | undefined
) => ({
  stateError: getFieldError(showValidationMessage, errors, 'state'),
  insuranceError: getFieldError(showValidationMessage, errors, 'insurance'),
});
